<h2 mat-dialog-title>Incorrect Role</h2>
<mat-dialog-content>
  <div class="flex flex-col items-center justify-center">
    <p>{{ incorrectRole }}</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button ctx-button--primary mat-dialog-close>Close</button>
</mat-dialog-actions>
